module.exports = __webpack_public_path__ + "static/img/wifiDevice.298eda23.png";